<template>
  <div v-if="showPerson">
    <div v-if="displayCollapsedBox" class="collapse-container">
        <div class="collapse-content" @click="toggleCollapse">
            <div>
              <div v-if="!disableRemove" class="collapse-icon" @click="removeClick">
                <IconRemove />
              </div>
            </div>
            <p :class="disabled ? 'collapse-title-disabled' : 'collapse-title'">
                <slot name="title"/>
            </p>
            <div>
              <div :class="[disabled ? 'collapse-icon-disabled' : 'collapse-icon', collapsed && !disabled && 'icon-rotate']">
                <IconChevronDown />
              </div>
            </div>
        </div>
        <Transition name="collapse">
            <div v-show="collapsed">
                <slot/>
            </div>
        </Transition>
    </div>
    <div v-else>
      <slot />
    </div>
  </div>
</template>

<script>
import IconRemove from '@/components/Icons/IconRemove.vue';
import IconChevronDown from '@/components/Icons/IconChevronDown.vue';
import persons from '@/mixins/persons';
import GA from '@/mixins/GA';
import enums from '@/mixins/enums';

export default {
  name: 'Collapse',
  components: {
    IconRemove,
    IconChevronDown,
  },
  mixins: [persons, GA, enums],
  props: {
    personCount: {
      type: Number,
      required: false,
      default: 1,
    },
    index: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableRemove: {
      type: Boolean,
      required: false,
      default: false,
    },
    openedIndex: {
      type: Number,
      required: false,
    },
    opened: {
      type: Boolean,
      required: false,
      default: false,
    },
    model: {
      type: Object,
      required: true,
    },
    triedGoToNextStep: {
      type: Boolean,
      required: false,
    },
    errors: {
      type: Array,
      required: false,
    },
    newPerson: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    if (this.opened) {
      this.collapsed = true;
    }
    this.$emit('child-loaded');
  },
  data() {
    return {
      collapsed: false,
    };
  },
  methods: {
    toggleCollapse() {
      if (!this.disabled) {
        this.collapsed = !this.collapsed;
        this.$emit('handle-next-step');

        if (this.collapsed) {
          this.$emit('change', this.index);
        }
      }
    },
    removeClick() {
      if (!this.disableRemove) {
        this.removePerson();
      }
    },
    removePerson() {
      const { index } = this;
      if (this.insuredPersons.length > 1) {
        // Remove all references in other persons
        // Addresses & Legal representatives
        this.insuredPersons
          .filter((_, pIndex) => pIndex !== index)
          .forEach((person) => {
            const {
              firstLegalRepresentative,
              // secondLegalRepresentative,
            } = person;
            if (person.addressSameAsPersonWithIndex === index) person.addressSameAsPersonWithIndex = null;
            if (person.addressSameAsPersonWithIndex > index) person.addressSameAsPersonWithIndex -= 1;
            if (firstLegalRepresentative.personIndex === index) {
              const { FirstLegalRepresentative_init } = this.$kotlin.model;
              const newPerson = FirstLegalRepresentative_init();
              newPerson.address.country = this.$store.getters.getSlovakia;
              newPerson.nationality = this.$store.getters.getSlovakia;
              person.firstLegalRepresentative = newPerson;
            }
            if (firstLegalRepresentative.personIndex > index) firstLegalRepresentative.personIndex -= 1;
          });
        this.model.currentPersonStepIndex = this.getCurrentPersonStepIndex(index);
        const oldCurrentPersonIndex = this.model.currentPersonIndex;
        this.model.currentPersonIndex = this.getCurrentPersonIndex(index);
        this.$store.commit('REMOVE_PERSON_ATTACHMENTS', index);
        // Remove person
        this.insuredPersons.splice(index, 1);
        if (this.insuredPersons.length === 1) {
          if (this.insuredPersons[0].isAdult) {
            this.model.insuranceType = this.InsuranceType.ADULT;
          } else {
            this.model.insuranceType = this.InsuranceType.CHILD;
          }
        }
        // First person cannot choose address from other persons
        this.insuredPersons[0].addressSameAsPersonWithIndex = -1;
        // Set new funnel sub type
        this.setFunnelSubType(this.insuredPersons);
        if (index === oldCurrentPersonIndex) {
          this.$router.goToStep(this.insuredPersons[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0[this.model.currentPersonStepIndex]);
        }
      }
    },
    getCurrentPersonIndex(removedIndex) {
      const lastPersonIndex = this.insuredPersons.length - 1;
      let newCurrentPersonIndex = this.model.currentPersonIndex;
      if (newCurrentPersonIndex === lastPersonIndex || removedIndex < newCurrentPersonIndex) {
        newCurrentPersonIndex -= 1;
      }
      return newCurrentPersonIndex;
    },
    getCurrentPersonStepIndex(removedIndex) {
      if (removedIndex < this.model.currentPersonIndex) return this.model.currentPersonStepIndex;
      if (removedIndex === (this.insuredPersons.length - 1)) return this.getLastStepOfPreviousPerson((removedIndex - 1));
      return 0;
    },
    getLastStepOfPreviousPerson(personIndex) {
      let lastStep = this.insuredPersons[personIndex].visitedSteps.array_hd7ov6$_0.length - 1;
      if (this.insuredPersons[personIndex].visitedSteps.array_hd7ov6$_0[lastStep] === 9) lastStep -= 1;
      return lastStep;
    },
  },
  computed: {
    displayCollapsedBox() {
      return this.personCount > 1;
    },
    showPerson() {
      return this.index <= this.model.currentPersonIndex || this.newPerson;
    },
    InsuranceType() { return this.enums.InsuranceTypeEnum; },
  },
  watch: {
    errors: {
      handler() {
        if (this.triedGoToNextStep) {
          this.$emit('handle-next-step');
        }
      },
    },
    triedGoToNextStep: {
      handler() {
        if (this.triedGoToNextStep) {
          const checkErrorAtIndex = this.errors.some((error) => error.endsWith(`_${this.index}`));
          this.collapsed = checkErrorAtIndex;
        }
      },
    },
    openedIndex: {
      handler(newValue) {
        this.collapsed = newValue === this.index;
      },
      deep: true,
    },
  },
};
</script>
